/**
 * 业务管理路由
 */
 const Layout = () => import(/* webpackChunkName: "Layout" */'@serviceapp/businessManage/Router.vue')
 export default [
     {
         path: '/businessManage',
         name: 'businessManage',
         component: Layout,
         meta: { text: '业务管理' },
         children: [
            {
                path: 'blacklistManage',
                name: 'blacklistManage',
                component: () => import(/* webpackChunkName: "blacklistManage" */'@serviceapp/businessManage/personManage/blacklistManage/Index.vue'),
                meta: { text: '黑名单管理' }
            },
            {
                path: 'personInfo',
                name: 'personInfo',
                component: () => import(/* webpackChunkName: "personInfo" */'@serviceapp/businessManage/personManage/personInfo/Index.vue'),
                meta: { text: '人员信息' }
            },
            {
                path: 'fangkeInfo',
                name: 'fangkeInfo',
                component: () => import(/* webpackChunkName: "fangkeInfo" */'@serviceapp/businessManage/personManage/fangkeInfo/Index.vue'),
                meta: { text: '访客信息' }
            },
            {
                path: 'zhinengsousuo',
                name: 'zhinengsousuo',
                component: () => import(/* webpackChunkName: "zhinengsousuo" */'@serviceapp/businessManage/personManage/zhinengsousuo/Index.vue'),
                meta: { text: '智能搜索' }
            },
             {
                 path: 'personApply',
                 name: 'personApply',
                 component: () => import(/* webpackChunkName: "personApply" */'@serviceapp/businessManage/personManage/personApply/Index.vue'),
                 meta: { text: '人员入校申请' }
             },
             {
                 path: 'personApplyWxb',
                 name: 'personApplyWxb',
                 component: () => import(/* webpackChunkName: "personApplyWxb" */'@serviceapp/businessManage/personManage/personApplyWxb/Index.vue'),
                 meta: { text: '网信办访客库' }
             },
             {
                 path: 'myReviewerApply',
                 name: 'myReviewerApply',
                 component: () => import(/* webpackChunkName: "myReviewerApply" */'@serviceapp/businessManage/personManage/myReviewerApply/Index.vue'),
                 meta: { text: '我的入校审批' }
             },
             // {
             //     path: 'peopleInput',
             //     name: 'peopleInput',
             //     component: () => import(/* webpackChunkName: "peopleInput" */'@serviceapp/businessManage/personManage/peopleInput/Index.vue'),
             //     meta: { text: '人员照片录入' }
             // },
            {
                path: 'trafficMange',
                name: 'trafficMange',
                component: () => import(/* webpackChunkName: "trafficMange" */'@serviceapp/businessManage/personManage/trafficMange/Index.vue'),
                meta: { text: '通行管理' }
            },
            // {
            //     path: 'visitorManage',
            //     name: 'visitorManage',
            //     component: () => import(/* webpackChunkName: "visitorManage" */'@serviceapp/businessManage/personManage/visitorManage/Index.vue'),
            //     meta: { text: '访客记录' }
            // },
            {
                path: 'visitorStatistics',
                name: 'visitorStatistics',
                component: () => import(/* webpackChunkName: "visitorStatistics" */'@serviceapp/businessManage/personManage/visitorStatistics/Index.vue'),
                meta: { text: '访客统计' }
            },
             // {
             //     path: 'personStatistics',
             //     name: 'personStatistics',
             //     component: () => import(/* webpackChunkName: "personStatistics" */'@serviceapp/businessManage/personManage/personStatistics/Index.vue'),
             //     meta: { text: '人员统计' }
             // },
            {
                path: 'securityManage',
                name: 'securityManage',
                component: () => import(/* webpackChunkName: "securityManage" */'@serviceapp/businessManage/personManage/securityManage/Index.vue'),
                meta: { text: '安保人员' }
            },
            {
                path: 'vehicleInfo',
                name: 'vehicleInfo',
                component: () => import(/* webpackChunkName: "vehicleInfo" */'@serviceapp/businessManage/vehicleManage/vehicleInfo/Index.vue'),
                meta: { text: '车辆信息' }
            },
            {
                path: 'statisticsCarManager',
                name: 'statisticsCarManager',
                component: () => import(/* webpackChunkName: "statisticsCarManager" */'@serviceapp/businessManage/vehicleManage/statisticsCarManager/Index.vue'),
                meta: { text: '车辆信息' }
            },
            {
                path: 'inOutInfo',
                name: 'inOutInfo',
                component: () => import(/* webpackChunkName: "inOutInfo" */'@serviceapp/businessManage/vehicleManage/inOutInfo/Index.vue'),
                meta: { text: '车辆统计' }
            },
            // {
            //     path: 'violationManage',
            //     name: 'violationManage',
            //     component: () => import(/* webpackChunkName: "violationManage" */'@serviceapp/businessManage/vehicleManage/violationManage/Index.vue'),
            //     meta: { text: '违停管理' }
            // },
            {
                path: 'speedManage',
                name: 'speedManage',
                component: () => import(/* webpackChunkName: "vehicleSpeedManage" */'@serviceapp/businessManage/vehicleManage/speedManage/Index.vue'),
                meta: { text: '违章管理' }
            },
            {
                path: 'violationSetManage',
                name: 'violationSetManage',
                component: () => import(/* webpackChunkName: "violationSetManage" */'@serviceapp/businessManage/vehicleManage/violationSetManage/Index.vue'),
                meta: { text: '违章设置' }
            },
            {
                path: 'blackCarManage',
                name: 'blackCarManage',
                component: () => import(/* webpackChunkName: "blackCarManage" */'@serviceapp/businessManage/vehicleManage/blackCarManage/Index.vue'),
                meta: { text: '黑名单管理' }
            },
            {
                path: 'vehicleGroup',
                name: 'vehicleGroup',
                component: () => import(/* webpackChunkName: "vehicleGroup" */'@serviceapp/businessManage/vehicleManage/vehicleGroup/Index.vue'),
                meta: { text: '车辆通行组管理' }
            },
             // {
             //     path: 'enterSchoolCarApply',
             //     name: 'enterSchoolCarApply',
             //     component: () => import(/* webpackChunkName: "enterSchoolCarApply" */'@serviceapp/businessManage/vehicleManage/enterSchoolCarApply/Index.vue'),
             //     meta: { text: '车辆统计' }
             // },
            // {
            //     path: 'smartXunjianManage',
            //     name: 'smartXunjianManage',
            //     component: ()=>import('@serviceapp/businessManage/personManage/smartXunjianManage/Index.vue'),
            //     meta: {text: '巡检任务'}
            // },
            // {
            //     path: 'mySmartXunjianManage',
            //     name: 'mySmartXunjianManage',
            //     component: ()=>import('@serviceapp/businessManage/personManage/mySmartXunjianManage/Index.vue'),
            //     meta: {text: '我的巡检'}
            // },
            // {
            //     path: 'placeAlarmManage',
            //     name: 'placeAlarmManage',
            //     component: ()=>import('@serviceapp/businessManage/placeAlarmManage/Index.vue'),
            //     meta: {text: '场所报警'}
            // },
            // {
            //     path: 'targetAlarm',
            //     name: 'targetAlarm',
            //     component: ()=>import('@serviceapp/businessManage/personManage/targetAlarm/Index.vue'),
            //     meta: {text: '目标告警'}
            // },
            // {
            //     path: 'xunjianViolationManage',
            //     name: 'xunjianViolationManage',
            //     component: ()=>import('@serviceapp/businessManage/personManage/xunjianViolationManage/Index.vue'),
            //     meta: {text: '巡检事件'}
            // },
           {
             path: 'aqgl/hiddenDangerRecord',
             name: 'hiddenDangerRecord',
             component: ()=>import('@serviceapp/businessManage/aqgl/hiddenDangerRecord/Index.vue'),
             meta: {text: '巡检事件'}
           },
             {
                 path: 'fireStatistics',
                 name: 'fireStatistics',
                 component: () => import('@serviceapp/businessManage/fireManage/fireStatistics/Index.vue'),
                 meta: { text: '设备管理' }
             },
             {
                 path: 'fireManage',
                 name: 'fireManage',
                 component: () => import('@serviceapp/businessManage/fireManage/fireManage/Index.vue'),
                 meta: { text: '报警记录' }
             },
             {
                 path: 'patrolPointManage',
                 name: 'patrolPointManage',
                 component: ()=>import('@serviceapp/businessManage/patrolManage/patrolPointManage/Index.vue'),
                 meta: {text: '巡更点管理'}
             },
             {
                 path: 'patrolRouteManage',
                 name: 'patrolRouteManage',
                 component: ()=>import('@serviceapp/businessManage/patrolManage/patrolRouteManage/Index.vue'),
                 meta: {text: '巡更路线管理'}
             },
             {
                 path: 'patrolTaskManage',
                 name: 'patrolTaskManage',
                 component: ()=>import('@serviceapp/businessManage/patrolManage/patrolTaskManage/Index.vue'),
                 meta: {text: '巡更任务管理'}
             },
             {
                 path: 'patrolEventManage',
                 name: 'patrolEventManage',
                 component: ()=>import('@serviceapp/businessManage/patrolManage/patrolEventManage/Index.vue'),
                 meta: {text: '巡更事件管理'}
             },
           {
             path: 'placeManage',
             name: 'placeManage',
             component: ()=>import('@serviceapp/businessManage/siteManage/site/Index.vue'),
             meta: {text: '场所信息'}
           },
             {
                 path: 'placeUserManage',
                 name: 'placeUserManage',
                 component: ()=>import('@serviceapp/businessManage/siteManage/building/Index.vue'),
                 meta: {text: '建筑物信息'}
             },
             {
                 path: 'visitingRequest',
                 name: 'visitingRequest',
                 component: ()=>import('@serviceapp/businessManage/personManage/visitingRequest/Index.vue'),
                 meta: {text: '全部访客申请记录'}
             },
             // {
             //     path: 'visitingRequestMy',
             //     name: 'visitingRequestMy',
             //     component: ()=>import('@serviceapp/businessManage/personManage/visitingRequestMy/Index.vue'),
             //     meta: {text: '我的访客申请记录'}
             // },
             {
                 path: 'sceneItemIcon',
                 name: 'sceneItemIcon',
                 component: ()=>import('@serviceapp/businessManage/sceneItemManage/sceneItemIcon/Index.vue'),
                 meta: {text: '场景项图标管理'}
             },
             {
                 path: 'cameraAnnotation',
                 name: 'cameraAnnotation',
                 component: ()=>import('@serviceapp/businessManage/sceneItemManage/cameraAnnotation/Index.vue'),
                 meta: {text: '摄像头标注'}
             },
             {
                 path: 'servicePersonnelInput',
                 name: 'servicePersonnelInput',
                 component: ()=>import('@serviceapp/businessManage/personManage/servicePersonnelInput/Index.vue'),
                 meta: {text: '服务人员入库申请'}
             },
             {
                 path: 'servicePersonnelAudit',
                 name: 'servicePersonnelAudit',
                 component: ()=>import('@serviceapp/businessManage/personManage/servicePersonnelAudit/Index.vue'),
                 meta: {text: '服务人员入库审核'}
             },
             {
                 path: 'visitorBlack',
                 name: 'visitorBlack',
                 component: ()=>import('@serviceapp/businessManage/personManage/visitorBlack/Index.vue'),
                 meta: {text: '访客黑名单'}
             },
             {
                 path: 'buildingList',
                 name: 'buildingList',
                 component: ()=>import('@serviceapp/businessManage/buildingManage/buildingList/Index.vue'),
                 meta: {text: '建筑资源列表'}
             },
         ]
     },
 ]
